import React from 'react';
import './SiteBeianRecords.css';

const PUBLIC_URL = process.env.PUBLIC_URL || '';

export const ICP_FILING_NUMBER = '渝ICP备2025065240号-4';
export const MPS_FILING_NUMBER = '渝公网安备50010302505607号';
export const ICP_FILING_URL = 'https://beian.miit.gov.cn/';
export const MPS_FILING_URL =
  'https://beian.mps.gov.cn/#/query/webSearch?code=50010302505607';
export const MPS_FILING_ICON_SRC = `${PUBLIC_URL}/assets/beian-mps-icon.png`;

type SiteBeianRecordsProps = {
  className?: string;
};

const SiteBeianRecords: React.FC<SiteBeianRecordsProps> = ({ className }) => {
  const rootClass = ['site-beian-records', className].filter(Boolean).join(' ');

  return (
    <div className={rootClass}>
      <a href={ICP_FILING_URL} rel="noreferrer" target="_blank">
        {ICP_FILING_NUMBER}
      </a>
      <span className="site-beian-records__sep" aria-hidden>
        ·
      </span>
      <span className="site-beian-records__mps">
        <img src={MPS_FILING_ICON_SRC} alt="" width={20} height={20} />
        <a href={MPS_FILING_URL} rel="noreferrer" target="_blank">
          {MPS_FILING_NUMBER}
        </a>
      </span>
    </div>
  );
};

export default SiteBeianRecords;
